/* tessara-category.js — Phase 3 category editorial page behaviour */

(function () {
  'use strict';

  /* ── Size charts (Printful specs, all Wear types) ── */
  const SIZE_CHARTS = {
    'AOP Hoodie': {
      note: 'Unisex fit. Chest and length measured in inches (garment laid flat).',
      headers: ['Size', 'Chest', 'Length'],
      rows: [
        ['XS', '15.5–16.5"', '24.5"'],
        ['S',  '17–18"',     '25.5"'],
        ['M',  '19.5–20.5"', '26.5"'],
        ['L',  '21.5–22.5"', '27.5"'],
        ['XL', '24–25"',     '28.5"'],
        ['2XL','26.5–27.5"', '29.5"'],
        ['3XL','28.5–29.5"', '30.5"'],
      ]
    },
    "AOP Women's T-Shirt": {
      note: 'Slim fit. Chest and length measured in inches (garment laid flat).',
      headers: ['Size', 'Chest', 'Length'],
      rows: [
        ['XS', '15.5"', '25.5"'],
        ['S',  '16.5"', '26"'],
        ['M',  '18"',   '26.5"'],
        ['L',  '19.5"', '27"'],
        ['XL', '21"',   '28"'],
        ['2XL','23"',   '29"'],
      ]
    },
    "AOP Men's T-Shirt": {
      note: 'Regular fit. Chest and length measured in inches (garment laid flat).',
      headers: ['Size', 'Chest', 'Length'],
      rows: [
        ['XS', '16.5"', '27"'],
        ['S',  '18"',   '28"'],
        ['M',  '20"',   '29"'],
        ['L',  '22"',   '30"'],
        ['XL', '24"',   '31"'],
        ['2XL','26"',   '32"'],
        ['3XL','28"',   '33"'],
      ]
    },
    'AOP Leggings': {
      note: 'High-waist. Body measurements in inches.',
      headers: ['Size', 'Waist', 'Hips', 'Length'],
      rows: [
        ['XS', '24–27"', '34.5–37.5"', '36"'],
        ['S',  '27–30"', '37.5–40.5"', '37"'],
        ['M',  '30–33"', '40.5–43.5"', '38"'],
        ['L',  '33–36"', '43.5–46.5"', '38.5"'],
        ['XL', '36–39"', '46.5–49.5"', '39"'],
        ['2XL','39–42"', '49.5–52.5"', '39.5"'],
      ]
    },
    'Bandana': {
      note: 'Square. Rolled hem. 100% sublimation polyester.',
      headers: ['Size', 'Dimensions'],
      rows: [
        ['S', '19.7" × 19.7"'],
        ['M', '22" × 22"'],
        ['L', '26" × 26"'],
      ]
    }
  };

  /* ── Upcharge lookup (matches PRODUCT_CONFIGS canonical prices) ── */
  const UPCHARGE = {
    'AOP Hoodie':        { '2XL': 8,  '3XL': 16 },
    "AOP Women's T-Shirt": { '2XL': 6 },
    "AOP Men's T-Shirt":   { '2XL': 10, '3XL': 16 }
  };

  function buildSizeTable(chart) {
    const ths = chart.headers.map(h => `<th>${h}</th>`).join('');
    const trs = chart.rows.map(r =>
      `<tr>${r.map(c => `<td>${c}</td>`).join('')}</tr>`
    ).join('');
    return `<table class="qv-sg__table"><thead><tr>${ths}</tr></thead><tbody>${trs}</tbody></table>`;
  }

  /* ─────────────────────────────────────────────────────────────────
     SUB-TYPE PILL SWITCHER
     Clicking a pill updates ?product=<handle> via History API
     and re-fetches the section via Section Rendering API.
  ───────────────────────────────────────────────────────────────── */
  function bindPills() {
    const pills = document.querySelectorAll('.cat-pill');
    if (!pills.length) return;

    pills.forEach(pill => {
      pill.addEventListener('click', async () => {
        /* Pattern sub-collection pills — navigate directly, no product_type filter */
        if (pill.dataset.pillUrl) {
          window.location.href = pill.dataset.pillUrl;
          return;
        }
        const type  = pill.dataset.pillType;
        const types = pill.dataset.pillTypes;
        const catPage  = window.__catPage || {};
        const baseUrl  = catPage.collectionUrl || window.location.pathname;
        const sectionId = catPage.sectionId || 'main-category-catalogue';

        /* Carry forward active S&D metafield filters (design_line, pattern, etc.) */
        const _cur = new URLSearchParams(window.location.search);
        let preservedQ = '';
        _cur.forEach((val, key) => {
          if (key.startsWith('filter.p.m.custom.')) {
            preservedQ += `&${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
          }
        });

        let newUrl;
        if (types) {
          const params = types.split(',').map(t => `filter.p.product_type=${encodeURIComponent(t.trim())}`).join('&');
          newUrl = `${baseUrl}?view=category-catalogue&${params}${preservedQ}`;
        } else if (type) {
          newUrl = `${baseUrl}?view=category-catalogue&filter.p.product_type=${encodeURIComponent(type)}${preservedQ}`;
        } else {
          newUrl = `${baseUrl}?view=category-catalogue${preservedQ}`;
        }

        const fetchUrl = `${newUrl}&sections=${sectionId}`;

        try {
          const res = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!res.ok) throw new Error(res.status);
          const data = await res.json();
          const html = data[sectionId];
          if (!html) throw new Error('section missing');
          const tmp  = document.createElement('div');
          tmp.innerHTML = html;
          /* Extract just the .cat-page--grid from the response, not the section wrapper */
          const newContent = tmp.querySelector('.cat-page--grid');
          const current    = document.querySelector('.cat-page--grid');
          if (current && newContent) {
            current.replaceWith(newContent);
          }
        } catch (e) {
          /* Fall back to hard navigation on fetch error */
          window.location = newUrl;
          return;
        }

        window.history.pushState({ productType: type }, '', newUrl);
        /* Re-bind after DOM swap */
        bindPills();
        bindStickyBack();
        bindQuickView();
        bindSetPicker();
        bindFilterbarAccordions();
        bindFilterbarLinks();
        bindFilterSearch();
        bindLoadMore();
        bindActiveStrip();
        bindMobileSheet();
        randomizeCardImages();
      });
    });
  }

  /* ─────────────────────────────────────────────────────────────────
     CATEGORY TABS (Products page only)
     role="tablist" pattern: arrow keys navigate, Enter/Space activate.
     In-place fetch updates the grid. aria-busy + aria-live feedback.
  ───────────────────────────────────────────────────────────────── */
  function bindCategoryTabs() {
    const tablist = document.getElementById('cat-category-tabs');
    if (!tablist) return;

    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    const status = document.getElementById('cat-tab-status');
    const catPage = window.__catPage || {};
    const sectionId = catPage.sectionId || 'category-catalogue';

    /* CAT_TYPES mirrors bindFilterbarLinks — used for in-place product_type filtering */
    const CAT_TYPES = {
      'wear':         ["AOP Men's T-Shirt","AOP Women's T-Shirt","AOP Hoodie","AOP Leggings","AOP Recycled Leggings with Pockets","AOP Sports Bra","AOP Longline Sports Bra","AOP Bucket Hat","AOP Neck Gaiter","AOP Headband","AOP Recycled Scrunchie","AOP Biker Shorts","AOP Women's Cropped Windbreaker","Bandana"],
      'decor':        ["Canvas","Matte Poster","Framed Matte Poster","Photo Poster","Framed Photo Poster","Matted Framed Poster","Throw Pillow","Pillow Case","Premium Pillow","Premium Pillow Case","Fleece Blanket","Sherpa Blanket","Wall Tapestry","Garden Flag"],
      'kitchen-bath': ["Hand Towel","Shower Curtain","Table Runner","Cloth Napkin Set","Placemat Set","Coaster","Mug","Color Inside Mug"],
      'all-else':     ["Tote Bag","Can Cooler","Mouse Pad","Spiral Notebook","Desk Mat"]
    };

    async function activateTab(tab, pushState) {
      const handle = tab.dataset.catTab;
      const types  = handle !== 'all-products' ? (CAT_TYPES[handle] || []) : [];

      let newUrl;
      const base = catPage.collectionUrl || window.location.pathname;
      if (types.length) {
        const ptParams = types.map(t => `filter.p.product_type=${encodeURIComponent(t)}`).join('&');
        newUrl = `${base}?view=category-catalogue&${ptParams}`;
      } else {
        newUrl = `${base}?view=category-catalogue`;
      }

      /* Announce loading */
      const grid = document.getElementById('cat-grid-inner');
      if (grid) grid.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Loading…';

      /* Mark tab active immediately for responsiveness */
      tabs.forEach(t => {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        t.setAttribute('tabindex', t === tab ? '0' : '-1');
        t.classList.toggle('cat-tab--active', t === tab);
      });

      const fetchUrl = `${newUrl}&sections=${sectionId}`;
      try {
        const res = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const html = data[sectionId];
        if (!html) throw new Error('section missing');

        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newContent = tmp.querySelector('.cat-page--grid');
        const current    = document.querySelector('.cat-page--grid');
        if (current && newContent) {
          current.replaceWith(newContent);
        }
      } catch (_) {
        window.location.href = newUrl;
        return;
      }

      if (pushState !== false) window.history.pushState({ catTab: handle }, '', newUrl);

      /* Announce result count */
      const resultEl = document.querySelector('.cat-results strong');
      const count    = resultEl ? resultEl.textContent : '';
      if (status) status.textContent = count ? `Showing ${count} products` : 'Products updated';

      /* Remove aria-busy (grid was replaced, re-query) */
      const newGrid = document.getElementById('cat-grid-inner');
      if (newGrid) newGrid.removeAttribute('aria-busy');

      /* Scroll to grid top if user is below the tablist */
      const tablistRect = tablist.getBoundingClientRect();
      if (tablistRect.bottom < 0) {
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        tablist.scrollIntoView({ behavior: prefersReduced ? 'instant' : 'smooth', block: 'nearest' });
      }

      /* Focus stays on the active tab */
      tab.focus();

      /* Re-bind after DOM swap */
      bindPills();
      bindCategoryTabs();
      bindStickyBack();
      bindQuickView();
      bindSetPicker();
      bindFilterbarAccordions();
      bindFilterbarLinks();
      bindFilterSearch();
      bindLoadMore();
      bindActiveStrip();
      bindMobileSheet();
      randomizeCardImages();
    }

    /* Click */
    tabs.forEach(tab => {
      tab.addEventListener('click', () => activateTab(tab));
    });

    /* Arrow keys */
    tablist.addEventListener('keydown', e => {
      const idx = tabs.indexOf(document.activeElement);
      if (idx === -1) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        const next = tabs[(idx + 1) % tabs.length];
        next.focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = tabs[(idx - 1 + tabs.length) % tabs.length];
        prev.focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        tabs[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        tabs[tabs.length - 1].focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTab(document.activeElement);
      }
    });
  }

  /* ─────────────────────────────────────────────────────────────────
     DESIGN-LINE CATEGORY CHIPS + PATTERN DROPDOWN
     In-place fetch filter for collection pages with subtype patterns.
  ───────────────────────────────────────────────────────────────── */
  function bindDesignLineFilters() {
    const catPage   = window.__catPage || {};
    const sectionId = catPage.sectionId || 'category-catalogue';
    const base      = catPage.collectionUrl || window.location.pathname;
    const status    = document.getElementById('cat-tab-status');

    async function fetchFilter(newUrl) {
      const grid = document.getElementById('cat-grid-inner');
      if (grid) grid.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Loading…';

      const fetchUrl = `${newUrl}&sections=${sectionId}`;
      try {
        const res = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const html = data[sectionId];
        if (!html) throw new Error('section missing');
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newContent = tmp.querySelector('.cat-page--grid');
        const current    = document.querySelector('.cat-page--grid');
        if (current && newContent) current.replaceWith(newContent);
      } catch (_) {
        window.location.href = newUrl;
        return;
      }

      window.history.pushState({}, '', newUrl);

      const resultEl = document.querySelector('.cat-results strong');
      const count    = resultEl ? resultEl.textContent : '';
      if (status) status.textContent = count ? `Showing ${count} products` : 'Products updated';

      const newGrid = document.getElementById('cat-grid-inner');
      if (newGrid) newGrid.removeAttribute('aria-busy');

      bindPills();
      bindDesignLineFilters();
      bindStickyBack();
      bindQuickView();
      bindSetPicker();
      bindFilterbarAccordions();
      bindFilterbarLinks();
      bindFilterSearch();
      bindLoadMore();
      bindActiveStrip();
      bindMobileSheet();
      randomizeCardImages();
    }

    function buildUrl() {
      const activeChip    = document.querySelector('.cat-dl-chip--active[data-dl-cat]:not([data-dl-cat=""])');
      const patternSelect = document.getElementById('cat-pattern-select');
      const params        = new URLSearchParams();
      params.set('view', 'category-catalogue');

      if (activeChip) {
        const types = (activeChip.dataset.dlTypes || '').split(',').filter(Boolean);
        types.forEach(t => params.append('filter.p.product_type', t.trim()));
      }
      if (patternSelect && patternSelect.value) {
        params.set('filter.p.m.custom.pattern', patternSelect.value);
      }
      return `${base}?${params.toString()}`;
    }

    /* Category chips */
    document.querySelectorAll('.cat-dl-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        document.querySelectorAll('.cat-dl-chip').forEach(c => {
          c.classList.remove('cat-dl-chip--active');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('cat-dl-chip--active');
        chip.setAttribute('aria-pressed', 'true');
        fetchFilter(buildUrl());
      });
    });

    /* Pattern dropdown */
    const patternSelect = document.getElementById('cat-pattern-select');
    if (patternSelect) {
      patternSelect.addEventListener('change', () => fetchFilter(buildUrl()));
    }
  }

  /* ─────────────────────────────────────────────────────────────────
     STICKY BACK-TO-EDIT PILL
     Fades out when footer enters viewport.
  ───────────────────────────────────────────────────────────────── */
  function bindStickyBack() {
    const pill   = document.getElementById('cat-stickyback');
    const footer = document.querySelector('footer, .site-footer');
    if (!pill || !footer) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (prefersReduced) {
            pill.style.display = entry.isIntersecting ? 'none' : '';
          } else {
            pill.classList.toggle('cat-stickyback--hidden', entry.isIntersecting);
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(footer);
  }

  /* ─────────────────────────────────────────────────────────────────
     QUICK VIEW MODAL
  ───────────────────────────────────────────────────────────────── */
  function bindQuickView() {
    const stage    = document.getElementById('qv-stage');
    const closeBtn = document.getElementById('qv-close');
    if (!stage) return;
    /* Guard: only bind once — QV modal stays in DOM across pill swaps and load-more */
    if (stage.dataset.qvBound) return;
    stage.dataset.qvBound = '1';

    let lastTrigger = null;

    /* Open quick view — event delegation handles all surfaces */
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-quick-view-open]');
      if (!trigger) return;
      e.preventDefault();
      const handle = trigger.dataset.productHandle
        || trigger.closest('[data-product-handle]')?.dataset?.productHandle;
      if (!handle) return;
      lastTrigger = trigger;
      openQuickView(handle);
    });

    /* Keyboard: Enter/Space on .pcard or vitrine tiles opens Quick View */
    document.addEventListener('keydown', e => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const card = e.target.closest('.pcard[data-product-handle], [data-quick-view-open][role="button"]');
      if (!card) return;
      e.preventDefault();
      lastTrigger = card;
      openQuickView(card.dataset.productHandle || card.closest('[data-product-handle]')?.dataset?.productHandle);
    });

    function openQuickView(handle) {
      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(product => populateQV(product))
        .catch(() => {});
    }

    function populateQV(product) {
      const imgs     = product.images || [];
      const variants = product.variants || [];

      /* Main image */
      const mainImg = document.getElementById('qv-main-img');
      if (mainImg && imgs[0]) {
        mainImg.src = imgs[0].replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_720x900.$1');
        mainImg.alt = product.title;
      }

      /* Gallery thumbnails */
      const gallery = document.getElementById('qv-gallery');
      if (gallery) {
        gallery.innerHTML = imgs.slice(0, 4).map((src, i) => `
          <button class="qv-img__thumb${i === 0 ? ' qv-img__thumb--active' : ''}"
                  data-src="${src.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_720x900.$1')}"
                  aria-label="Image ${i + 1}"
                  tabindex="0">
            <img src="${src.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_120x150.$1')}"
                 alt=""
                 width="52"
                 height="52">
          </button>
        `).join('');

        gallery.querySelectorAll('.qv-img__thumb').forEach(thumb => {
          thumb.addEventListener('click', () => {
            mainImg.src = thumb.dataset.src;
            gallery.querySelectorAll('.qv-img__thumb').forEach(t => t.classList.remove('qv-img__thumb--active'));
            thumb.classList.add('qv-img__thumb--active');
          });
        });
      }

      /* Text fields */
      const eyebrow = document.getElementById('qv-eyebrow');
      const title   = document.getElementById('qv-title');
      const type    = document.getElementById('qv-type');
      const price   = document.getElementById('qv-price');
      const meta    = document.getElementById('qv-meta');
      const pdpLink = document.getElementById('qv-pdp-link');

      if (eyebrow) eyebrow.textContent = product.vendor || '';
      if (title)   title.textContent   = product.title;
      if (type)    type.textContent    = product.product_type;
      if (price)   price.textContent   = formatMoney(product.price_min);
      if (pdpLink) pdpLink.href        = `/products/${product.handle}`;

      /* Material spec from metafields if surfaced in variants body_html */
      if (meta) {
        const spec = variants[0]?.option2 || '';
        meta.innerHTML = spec ? `<strong>Made of</strong> ${spec}` : '';
      }

      /* Store product type for size guide and toggle trigger visibility */
      const sgPanel   = document.getElementById('qv-sg');
      const sgTrigBtn = document.getElementById('qv-size-guide-trigger');
      if (sgPanel) sgPanel.dataset.productType = product.product_type;
      if (sgTrigBtn) sgTrigBtn.style.display = SIZE_CHARTS[product.product_type] ? '' : 'none';

      /* Size chips */
      const sizesEl    = document.getElementById('qv-sizes');
      const sizeLabelEl = document.querySelector('.qv-size-label');
      const atcBtn     = document.getElementById('qv-atc');
      if (sizesEl) {
        const isDefaultOnly = (variants.length === 1 && variants[0].option1 === 'Default Title')
          || (product.options?.length === 1 && product.options[0] === 'Title');

        if (isDefaultOnly) {
          /* Single no-option product — hide size section, auto-select variant */
          if (sizeLabelEl) sizeLabelEl.style.display = 'none';
          sizesEl.style.display = 'none';
          sizesEl.innerHTML = '';
          const selectedVariantId = variants[0].id;
          if (price) price.textContent = formatMoney(variants[0].price);
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = `Add to cart — ${formatMoney(variants[0].price)}`;
            atcBtn.onclick = () => {
              const qty = parseInt(document.getElementById('qv-qty-input')?.value, 10) || 1;
              addToCart(selectedVariantId, qty)
                .then(() => { closeQV(); return window.tessaraCart?.refresh?.(); })
                .then(() => window.openCartDrawer?.())
                .catch(err => {
                  const errEl = document.getElementById('qv-error');
                  if (errEl) { errEl.textContent = err.message || 'Could not add to cart. Please try again.'; errEl.style.display = 'block'; }
                });
            };
          }
        } else {
          if (sizeLabelEl) sizeLabelEl.style.display = '';
          sizesEl.style.display = '';

          const upchargeMap = UPCHARGE[product.product_type] || {};
          sizesEl.innerHTML = variants.map(v => {
            const up = upchargeMap[v.option1];
            const upAttr = up ? ` data-upcharge="+$${up}"` : '';
            const upClass = up ? ' tds-size-chip--upcharge' : '';
            return `<button class="tds-size-chip${upClass}"
                            data-variant-id="${v.id}"
                            data-price="${v.price}"${upAttr}
                            aria-label="${v.option1}${up ? ` (+$${up})` : ''}">
              ${v.option1}
            </button>`;
          }).join('');

          /* Update price and ATC label on chip click */
          let selectedVariantId = null;
          sizesEl.querySelectorAll('.tds-size-chip').forEach(chip => {
            chip.addEventListener('click', () => {
              sizesEl.querySelectorAll('.tds-size-chip').forEach(c => c.classList.remove('tds-size-chip--active'));
              chip.classList.add('tds-size-chip--active');
              selectedVariantId = chip.dataset.variantId;
              if (price) price.textContent = formatMoney(parseInt(chip.dataset.price, 10));
              if (atcBtn) {
                atcBtn.disabled = false;
                atcBtn.textContent = `Add to cart — ${formatMoney(parseInt(chip.dataset.price, 10))}`;
              }
              /* Variant image swap */
              const vid = parseInt(selectedVariantId, 10);
              const variant = variants.find(v => v.id === vid);
              if (variant && variant.featured_image && mainImg) {
                const src = variant.featured_image.src.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_720x900.$1');
                mainImg.src = src;
              }
            });
          });

          /* ATC */
          if (atcBtn) {
            atcBtn.disabled = true;
            atcBtn.textContent = 'Add to cart';
            atcBtn.onclick = () => {
              if (!selectedVariantId) return;
              const qty = parseInt(document.getElementById('qv-qty-input')?.value, 10) || 1;
              addToCart(selectedVariantId, qty)
                .then(() => { closeQV(); return window.tessaraCart?.refresh?.(); })
                .then(() => window.openCartDrawer?.())
                .catch(err => {
                  const errEl = document.getElementById('qv-error');
                  if (errEl) { errEl.textContent = err.message || 'Could not add to cart. Please try again.'; errEl.style.display = 'block'; }
                });
            };
          }
        }
      }

      /* Quantity stepper — reset on every QV open, bind +/- */
      const qtyInput = document.getElementById('qv-qty-input');
      const qtyDec   = document.getElementById('qv-qty-dec');
      const qtyInc   = document.getElementById('qv-qty-inc');
      if (qtyInput) qtyInput.value = '1';
      if (qtyDec) qtyDec.onclick = () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      };
      if (qtyInc) qtyInc.onclick = () => {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      };

      /* Show */
      stage.style.display = '';
      stage.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(stage);
      closeBtn && closeBtn.focus();
    }

    function closeQV() {
      stage.style.display = 'none';
      stage.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lastTrigger && lastTrigger.focus();
      const sgPanel = document.getElementById('qv-sg');
      if (sgPanel) sgPanel.style.display = 'none';
    }

    /* Close triggers */
    closeBtn && closeBtn.addEventListener('click', closeQV);
    stage.addEventListener('click', e => { if (e.target === stage) closeQV(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && stage.style.display !== 'none') closeQV();
    });

    /* Size guide */
    const sgTrigger = document.getElementById('qv-size-guide-trigger');
    const sgBack    = document.getElementById('qv-sg-back');
    const sgPanel   = document.getElementById('qv-sg');

    if (sgTrigger && sgPanel) {
      sgTrigger.addEventListener('click', () => {
        const type  = sgPanel.dataset.productType;
        const chart = SIZE_CHARTS[type];
        if (!chart) return;
        const noteEl = document.getElementById('qv-sg-note');
        const bodyEl = document.getElementById('qv-sg-body');
        if (noteEl) noteEl.textContent = chart.note || '';
        if (bodyEl) bodyEl.innerHTML   = buildSizeTable(chart);
        sgPanel.style.display = 'block';
        sgBack && sgBack.focus();
      });
    }

    if (sgBack && sgPanel) {
      sgBack.addEventListener('click', () => {
        sgPanel.style.display = 'none';
        sgTrigger && sgTrigger.focus();
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────────
     SET PICKER SHEET
  ───────────────────────────────────────────────────────────────── */
  function bindSetPicker() {
    const stage   = document.getElementById('sp-stage');
    const sheet   = document.getElementById('sp-sheet');
    const closeBtn= document.getElementById('sp-close');
    const backBtn = document.getElementById('sp-back');
    if (!stage) return;

    let lastTrigger = null;

    document.querySelectorAll('[data-set-picker-open]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const handlesStr = trigger.dataset.handles || '';
        const label      = trigger.dataset.label    || 'Set';
        if (!handlesStr) return;
        lastTrigger = trigger;
        openSetPicker(handlesStr.split(',').map(h => h.trim()), label);
      });
    });

    async function openSetPicker(handles, label) {
      /* Reset confirm state */
      const confirm = document.getElementById('sp-confirm');
      const body    = document.getElementById('sp-body');
      const titleEl = document.getElementById('sp-title');
      if (confirm) confirm.classList.remove('sp-confirm--visible');
      if (titleEl) titleEl.textContent = `Build your ${label}`;

      /* Fetch each product */
      const products = await Promise.all(
        handles.map(h => fetch(`/products/${h}.js`).then(r => r.json()).catch(() => null))
      ).then(ps => ps.filter(Boolean));

      /* Render rows */
      if (body) {
        const upchargeMap = UPCHARGE;
        body.innerHTML = products.map((p, i) => {
          const variants = p.variants || [];
          const upMap    = upchargeMap[p.product_type] || {};
          const thumb    = p.featured_image
            ? `<img src="${p.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_128x128.$1')}"
                    alt="${p.title.replace(/"/g, '&quot;')}"
                    width="64" height="64" loading="lazy">`
            : '';
          const isDefaultOnly = variants.length === 1 && variants[0].option1 === 'Default Title';
          const chips = isDefaultOnly ? '' : variants.map(v => {
            const up = upMap[v.option1];
            const upAttr = up ? ` data-upcharge="+$${up}"` : '';
            const upClass = up ? ' tds-size-chip--upcharge' : '';
            return `<button class="tds-size-chip${upClass}"
                            data-variant-id="${v.id}"
                            data-price="${v.price}"${upAttr}
                            data-row="${i}"
                            aria-label="${v.option1}${up ? ` +$${up}` : ''}">
              ${v.option1}
            </button>`;
          }).join('');

          const defaultAttrs = isDefaultOnly
            ? ` data-default-only data-variant-id="${variants[0].id}" data-price="${variants[0].price}"`
            : '';
          return `<div class="sp-row" data-row="${i}" data-product-handle="${p.handle}"${defaultAttrs}>
            <div class="sp-row__thumb">${thumb}</div>
            <div class="sp-row__copy">
              <div class="sp-row__top">
                <div>
                  <p class="sp-row__title">
                    ${p.title}
                    <small>${p.product_type || ''}</small>
                  </p>
                </div>
                <p class="sp-row__price" data-row-price="${i}">
                  ${formatMoney(p.price_min)}
                </p>
              </div>
              <div class="sp-row__sizes" data-row-sizes="${i}"${isDefaultOnly ? ' style="display:none"' : ''}>${chips}</div>
              <p class="sp-row__hint" id="sp-hint-${i}"${isDefaultOnly ? ' style="display:none"' : ''}>Please pick a size to continue.</p>
            </div>
          </div>`;
        }).join('');
      }

      /* Show sheet */
      stage.style.display = '';
      stage.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(stage);
      closeBtn && closeBtn.focus();

      /* Bind chip events */
      const selectedVariants = new Array(products.length).fill(null);

      /* Auto-select single-variant (no-option) products */
      if (body) {
        body.querySelectorAll('.sp-row[data-default-only]').forEach(row => {
          const idx = parseInt(row.dataset.row, 10);
          selectedVariants[idx] = { id: row.dataset.variantId, price: parseInt(row.dataset.price, 10) };
        });
      }

      const totalEl   = document.getElementById('sp-total');
      const countEl   = document.getElementById('sp-count-label');
      const atcBtn    = document.getElementById('sp-atc');

      function updateFooter() {
        const selected = selectedVariants.filter(Boolean);
        const total    = selectedVariants.reduce((acc, v) => acc + (v ? v.price : 0), 0);
        const n        = selected.length;
        if (totalEl) totalEl.textContent = n > 0 ? formatMoney(total) : '';
        if (countEl) countEl.textContent = `${n} of ${products.length} sizes chosen`;
        if (atcBtn) {
          atcBtn.disabled  = n === 0;
          atcBtn.textContent = n > 0
            ? `Add ${n} item${n > 1 ? 's' : ''} to cart`
            : `Add 0 items to cart`;
        }
      }

      (body || stage).querySelectorAll('.tds-size-chip').forEach(chip => {
        chip.addEventListener('click', () => {
          const row     = parseInt(chip.dataset.row, 10);
          const varId   = chip.dataset.variantId;
          const price   = parseInt(chip.dataset.price, 10);

          /* Deselect siblings */
          (body || stage).querySelectorAll(`.tds-size-chip[data-row="${row}"]`).forEach(c =>
            c.classList.remove('tds-size-chip--active')
          );
          chip.classList.add('tds-size-chip--active');

          selectedVariants[row] = { id: varId, price };

          /* Update per-row price */
          const rowPriceEl = (body || stage).querySelector(`[data-row-price="${row}"]`);
          if (rowPriceEl) rowPriceEl.textContent = formatMoney(price);

          /* Hide hint */
          const hint = document.getElementById(`sp-hint-${row}`);
          if (hint) hint.style.display = 'none';

          updateFooter();
        });
      });

      /* Add to cart */
      if (atcBtn) {
        atcBtn.onclick = async () => {
          const chosen = selectedVariants.filter(Boolean);
          if (chosen.length === 0) return;

          if (chosen.length < products.length) {
            /* Partial add — surface hints for missing rows */
            selectedVariants.forEach((v, i) => {
              if (!v) {
                const hint = document.getElementById(`sp-hint-${i}`);
                if (hint) hint.style.display = '';
              }
            });
            return;
          }

          /* All selected — add atomically */
          try {
            await addToCartMulti(chosen.map(v => ({ id: v.id, quantity: 1 })));
            showConfirm(products.length, label);
          } catch (err) {
            /* Show error inline */
          }
        };
      }

      updateFooter();
    }

    function showConfirm(count, label) {
      const body    = document.getElementById('sp-body');
      const footer  = sheet ? sheet.querySelector('.sp-sheet__footer') : null;
      const confirm = document.getElementById('sp-confirm');
      const titleEl = document.getElementById('sp-confirm-title');
      if (body)    body.style.display    = 'none';
      if (footer)  footer.style.display  = 'none';
      if (confirm) confirm.classList.add('sp-confirm--visible');
      if (titleEl) titleEl.textContent   = `${count} piece${count > 1 ? 's' : ''} added to your cart`;

      /* Refresh cart drawer */
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    function closeSP() {
      stage.style.display = 'none';
      stage.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* Reset body/footer visibility */
      const body   = document.getElementById('sp-body');
      const footer = sheet ? sheet.querySelector('.sp-sheet__footer') : null;
      if (body)   body.style.display   = '';
      if (footer) footer.style.display = '';
      lastTrigger && lastTrigger.focus();
    }

    closeBtn && closeBtn.addEventListener('click', closeSP);
    backBtn  && backBtn.addEventListener ('click', closeSP);
    stage.addEventListener('click', e => { if (e.target === stage) closeSP(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && stage.style.display !== 'none') closeSP();
    });

    const continueBtn = document.getElementById('sp-confirm-continue');
    continueBtn && continueBtn.addEventListener('click', closeSP);
  }

  /* ─────────────────────────────────────────────────────────────────
     CART HELPERS
  ───────────────────────────────────────────────────────────────── */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    }).then(r => {
      if (!r.ok) return r.json().then(e => Promise.reject(new Error(e.message || 'Cart error')));
      return r.json();
    }).then(data => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return data;
    });
  }

  function addToCartMulti(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    }).then(r => {
      if (!r.ok) return r.json().then(e => Promise.reject(new Error(e.message || 'Cart error')));
      return r.json();
    }).then(data => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return data;
    });
  }

  /* ─────────────────────────────────────────────────────────────────
     FOCUS TRAP
  ───────────────────────────────────────────────────────────────── */
  function trapFocus(container) {
    const focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];

    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    container.addEventListener('keydown', handler);
    /* Remove when closed */
    container.addEventListener('keydown', e => {
      if (e.key === 'Escape') container.removeEventListener('keydown', handler);
    }, { once: false });
  }

  /* ─────────────────────────────────────────────────────────────────
     MONEY FORMATTER
  ───────────────────────────────────────────────────────────────── */
  function formatMoney(cents) {
    const d = Math.floor(cents / 100);
    const c = cents % 100;
    if (c === 0) return `$${d}`;
    return `$${d}.${String(c).padStart(2, '0')}`;
  }

  /* ─────────────────────────────────────────────────────────────────
     FILTERBAR ACCORDION DROPDOWNS
  ───────────────────────────────────────────────────────────────── */
  let _fbAbort = null;

  function bindFilterbarAccordions() {
    const bar = document.getElementById('cat-filterbar');
    if (!bar) return;

    if (_fbAbort) _fbAbort.abort();
    _fbAbort = new AbortController();
    const { signal } = _fbAbort;

    const toggles = bar.querySelectorAll('[data-accordion-toggle]');

    function openAccordion(btn) {
      const container = btn.closest('[data-filter-accordion]');
      const content = container && container.querySelector('[data-accordion-content]');
      if (!content) return;
      btn.setAttribute('aria-expanded', 'true');
      content.classList.remove('hidden');
      const chevron = btn.querySelector('[aria-hidden="true"]');
      if (chevron) chevron.style.transform = 'rotate(180deg)';
    }

    function closeAccordion(btn) {
      const container = btn.closest('[data-filter-accordion]');
      const content = container && container.querySelector('[data-accordion-content]');
      if (!content) return;
      btn.setAttribute('aria-expanded', 'false');
      content.classList.add('hidden');
      const chevron = btn.querySelector('[aria-hidden="true"]');
      if (chevron) chevron.style.transform = 'rotate(0deg)';
    }

    function closeAll(except) {
      toggles.forEach(btn => { if (btn !== except) closeAccordion(btn); });
    }

    toggles.forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        if (expanded) { closeAccordion(btn); } else { openAccordion(btn); }
      });
    });

    /* Close on outside click — use .closest() so this survives DOM swaps */
    document.addEventListener('click', e => {
      if (e.target.closest('#cat-filterbar')) return;
      closeAll(null);
    }, { signal });

    /* Close on Escape */
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeAll(null);
    }, { signal });

    /* Auto-open relevant panel when URL has an active custom filter.
       Pattern takes priority: when pattern params are present (including
       after the first pattern selection alongside active design_lines),
       open the Pattern dropdown so the user can immediately add more.
       Only fall back to Collection when pattern is absent. */
    const _params = new URLSearchParams(window.location.search);
    if (_params.has('filter.p.m.custom.pattern')) {
      const _btn = bar.querySelector('#filter-accordion-pattern');
      if (_btn) openAccordion(_btn);
    } else if (_params.has('filter.p.m.custom.design_line')) {
      const _btn = bar.querySelector('#filter-accordion-collections');
      if (_btn) openAccordion(_btn);
    } else if (_params.has('filter.p.product_type')) {
      const _btn = bar.querySelector('#filter-accordion-product-type');
      if (_btn) openAccordion(_btn);
    }
  }

  /* ─────────────────────────────────────────────────────────────────
     INFINITE SCROLL / LOAD MORE
     Appends next-page cards to the existing grid instead of navigating.
     Auto-triggers via IntersectionObserver when the button enters view.
     Manual click scrolls to the first newly appended card.
  ───────────────────────────────────────────────────────────────── */
  let _loadMoreObserver = null;

  function bindLoadMore() {
    /* Disconnect any previous observer (survives section swaps). */
    if (_loadMoreObserver) { _loadMoreObserver.disconnect(); _loadMoreObserver = null; }

    const btn  = document.querySelector('.cat-pagination__btn');
    const hint = document.querySelector('.cat-pagination__hint');
    if (!btn) return;

    let loading = false;

    async function loadNext() {
      if (loading) return;
      const nextHref = btn.dataset.nextHref || btn.getAttribute('href');
      if (!nextHref) return;

      loading = true;
      const origText = btn.textContent;
      btn.textContent = 'Loading…';
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';

      const sectionId = (window.__catPage || {}).sectionId || 'category-catalogue';
      /* Strip any baked-in sections param from paginate.next.url before appending ours. */
      const cleanUrl = new URL(nextHref, window.location.origin);
      cleanUrl.searchParams.delete('sections');
      const sep = cleanUrl.search ? '&' : '?';
      const fetchUrl = cleanUrl.pathname + cleanUrl.search + sep + 'sections=' + sectionId;

      try {
        const res = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        const html = data[sectionId];
        if (!html) throw new Error('section missing');
        const tmp  = document.createElement('div');
        tmp.innerHTML = html;

        const newInner      = tmp.querySelector('#cat-grid-inner');
        const existingInner = document.getElementById('cat-grid-inner');
        if (!newInner || !existingInner) throw new Error('grid missing');

        const newCards = Array.from(newInner.children);
        if (!newCards.length) throw new Error('no cards');

        newCards.forEach(card => existingInner.appendChild(card));

        /* Update hint with DOM count + server total. */
        const totalLoaded = existingInner.children.length;
        const serverHint  = tmp.querySelector('.cat-pagination__hint');
        if (hint && serverHint) {
          const m = serverHint.textContent.match(/of\s+([\d,]+)/i);
          const total = m ? m[1] : '';
          hint.textContent = 'Showing ' + totalLoaded + (total ? ' of ' + total : '');
        }

        /* Update or remove the button. */
        const newBtn = tmp.querySelector('.cat-pagination__btn');
        if (newBtn) {
          const nextNext = newBtn.dataset.nextHref || newBtn.getAttribute('href') || newBtn.getAttribute('data-next-href');
          btn.dataset.nextHref = nextNext;
          btn.textContent = origText;
          btn.style.opacity      = '';
          btn.style.pointerEvents = '';
        } else {
          /* All pages loaded — remove button and stop observing. */
          if (_loadMoreObserver) { _loadMoreObserver.disconnect(); _loadMoreObserver = null; }
          btn.remove();
        }

        /* Re-bind quick-view/set-picker on new cards. */
        bindQuickView();
        bindSetPicker();
        randomizeCardImages();

      } catch (_) {
        /* Restore button — never navigate away (would lose all already-loaded pages) */
        btn.textContent = origText;
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      } finally {
        loading = false;
      }
    }

    btn.addEventListener('click', e => {
      e.preventDefault();
      loadNext();
    });

    /* Infinite scroll: trigger 300px before the button enters the viewport. */
    _loadMoreObserver = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '0px 0px 300px 0px' });
    _loadMoreObserver.observe(btn);
  }

  /* ─────────────────────────────────────────────────────────────────
     FILTERBAR LINK INTERCEPTION
     Ensures all filter <a> links inside the filterbar preserve
     ?view=category-catalogue so the page stays on this view.
  ───────────────────────────────────────────────────────────────── */
  function _fbMultiToggle(e, paramKey, datasetKey) {
    e.preventDefault();
    const val = e.target.closest('a').dataset[datasetKey];

    // Pattern filter routing — two cases where S&D can't AND the combination:
    // 1. Hub pages (decor/wear/etc.): S&D ignores custom.pattern on smart collections → route to /collections/all
    // 2. /collections/all with active product_type params: pattern + product_type returns 0 via S&D → drop product_type
    if (paramKey === 'filter.p.m.custom.pattern') {
      const HUB = ['wear', 'decor', 'kitchen-bath', 'all-else'];
      const catHandle = window.__catPage && window.__catPage.collectionHandle;
      if (HUB.includes(catHandle)) {
        const existing = new URLSearchParams(window.location.search).getAll(paramKey);
        const idx = existing.indexOf(val);
        if (idx > -1) existing.splice(idx, 1); else existing.push(val);
        const p = new URLSearchParams();
        existing.forEach(v => p.append(paramKey, v));
        p.set('view', 'category-catalogue');
        window.location.href = '/collections/all?' + p.toString();
        return;
      }
      if (window.location.pathname === '/collections/all') {
        const cur = new URLSearchParams(window.location.search);
        const existing = cur.getAll(paramKey);
        const idx = existing.indexOf(val);
        if (idx > -1) existing.splice(idx, 1); else existing.push(val);
        cur.delete(paramKey);
        existing.forEach(v => cur.append(paramKey, v));
        cur.delete('filter.p.product_type'); // can't AND with custom.pattern on /collections/all
        cur.set('view', 'category-catalogue');
        window.location.href = '/collections/all?' + cur.toString();
        return;
      }
    }

    const params = new URLSearchParams(window.location.search);
    const active = params.getAll(paramKey);
    const idx = active.indexOf(val);
    if (idx > -1) active.splice(idx, 1); else active.push(val);
    params.delete(paramKey);
    active.forEach(v => params.append(paramKey, v));
    params.set('view', 'category-catalogue');
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  function bindFilterSearch() {
    document.querySelectorAll('[data-filter-search]').forEach(input => {
      if (input.dataset.searchBound) return;
      input.dataset.searchBound = '1';
      input.addEventListener('input', function () {
        const q = this.value.trim().toLowerCase();
        const content = this.closest('[data-accordion-content]');
        if (!content) return;
        const overflow = content.querySelector('[data-filter-overflow]');
        if (q && overflow) overflow.classList.remove('hidden');
        content.querySelectorAll('li').forEach(li => {
          li.style.display = (!q || li.textContent.toLowerCase().includes(q)) ? '' : 'none';
        });
        if (!q && overflow) {
          const btn = content.querySelector('[data-show-more]');
          if (!btn || btn.getAttribute('aria-expanded') !== 'true') overflow.classList.add('hidden');
        }
      });
    });
  }

  function bindFilterbarLinks() {
    // Single document-level listener — survives all DOM swaps.
    // Resolves #cat-filterbar at click time so re-binding after AJAX swaps is not needed.
    if (document._fbLinksReady) return;
    document._fbLinksReady = true;

    document.addEventListener('click', e => {
      const bar = document.getElementById('cat-filterbar');
      if (!bar || !bar.contains(e.target)) return;

      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript')) return;

      // Multi-select: design line (collection) filter
      if ('colFilter' in link.dataset) {
        _fbMultiToggle(e, 'filter.p.m.custom.design_line', 'colFilter');
        return;
      }

      // Multi-select: pattern filter
      if ('patternFilter' in link.dataset) {
        _fbMultiToggle(e, 'filter.p.m.custom.pattern', 'patternFilter');
        return;
      }

      // "All Patterns" — clear pattern param
      if ('patAll' in link.dataset) {
        e.preventDefault();
        const params = new URLSearchParams(window.location.search);
        params.delete('filter.p.m.custom.pattern');
        params.set('view', 'category-catalogue');
        window.location.href = window.location.pathname + '?' + params.toString();
        return;
      }

      // Category filter — on /collections/all, convert to product_type in-place filter.
      // Navigating away (Decision D-D) is only correct when the user is already on a
      // specific collection page. On /collections/all the user expects filtering in place.
      if ('catHandle' in link.dataset && window.location.pathname === '/collections/all') {
        e.preventDefault();
        const handle = link.dataset.catHandle;
        const CAT_TYPES = {
          'wear':         ["AOP Men's T-Shirt","AOP Women's T-Shirt","AOP Hoodie","AOP Leggings","AOP Recycled Leggings with Pockets","AOP Sports Bra","AOP Longline Sports Bra","AOP Bucket Hat","AOP Neck Gaiter","Bandana"],
          'decor':        ["Canvas","Matte Poster","Framed Matte Poster","Photo Poster","Framed Photo Poster","Matted Framed Poster","Throw Pillow","Pillow Case","Premium Pillow","Premium Pillow Case","Fleece Blanket","Sherpa Blanket","Wall Tapestry","Garden Flag"],
          'kitchen-bath': ["Shower Curtain","Table Runner","Cloth Napkin Set","Placemat Set","Coaster","Mug","Color Inside Mug"],
          'all-else':     ["Tote Bag","Can Cooler","Mouse Pad","Spiral Notebook"]
        };
        const types = CAT_TYPES[handle] || [];
        const params = new URLSearchParams(window.location.search);
        const currentTypes = params.getAll('filter.p.product_type');
        // Toggle: if every active product_type belongs to this category, deselect it
        const isActive = types.length > 0 && currentTypes.length > 0 &&
                         currentTypes.every(t => types.includes(t));
        params.delete('filter.p.product_type');
        params.delete('filter.p.m.custom.pattern');
        params.delete('filter.p.m.custom.design_line');
        if (!isActive) {
          types.forEach(t => params.append('filter.p.product_type', t));
        }
        params.set('view', 'category-catalogue');
        window.location.href = '/collections/all?' + params.toString();
        return;
      }

      // Product type filter — toggle: click active type deselects, click inactive selects.
      // Replaces the old href (which always set the type, never removed it).
      if ('ptFilter' in link.dataset) {
        e.preventDefault();
        const type = link.dataset.ptFilter;
        const params = new URLSearchParams(window.location.search);
        const currentTypes = params.getAll('filter.p.product_type');
        params.delete('filter.p.product_type');
        if (!currentTypes.includes(type)) {
          params.append('filter.p.product_type', type);
        }
        // Carry forward design_line and pattern params if present
        // (already in params since we only deleted product_type above)
        params.set('view', 'category-catalogue');
        window.location.href = window.location.pathname + '?' + params.toString();
        return;
      }

      // All other links (subtype accordion, etc.): ensure view=category-catalogue
      // and carry forward any active filter.p.m.custom.* params (design_line, pattern).
      try {
        const u = new URL(href, window.location.origin);
        const cur = new URLSearchParams(window.location.search);
        let modified = false;
        if (u.searchParams.get('view') !== 'category-catalogue') {
          u.searchParams.set('view', 'category-catalogue');
          modified = true;
        }
        cur.forEach((val, key) => {
          if (key.startsWith('filter.p.m.custom.') && !u.searchParams.has(key)) {
            u.searchParams.append(key, val);
            modified = true;
          }
        });
        if (modified) {
          e.preventDefault();
          window.location.href = u.toString();
        }
      } catch (_) { /* malformed href — let browser handle */ }
    });
  }

  /* ─────────────────────────────────────────────────────────────────
     ACTIVE FILTER STRIP
     Reads filter.p.m.custom.* params from the URL, builds remove-link
     pills, and populates both the desktop strip and the mobile chip row.
  ───────────────────────────────────────────────────────────────── */
  function _buildRemoveUrl(key, value) {
    const u = new URL(window.location.href);
    const remaining = u.searchParams.getAll(key).filter(v => v !== value);
    u.searchParams.delete(key);
    remaining.forEach(v => u.searchParams.append(key, v));
    return u.toString();
  }

  function bindActiveStrip() {
    const strip = document.getElementById('cat-active-strip');
    const pillsContainer = document.getElementById('cat-strip-pills');
    const mobChips = document.getElementById('cat-mob-chips');
    if (!strip || !pillsContainer) return;

    const params = new URLSearchParams(window.location.search);
    const active = [];
    params.forEach((value, key) => {
      if (key.startsWith('filter.p.m.custom.')) active.push({ key, value });
    });

    if (active.length === 0) {
      strip.style.display = 'none';
      if (mobChips) mobChips.innerHTML = '';
      return;
    }

    strip.style.removeProperty('display');

    const html = active.map(({ key, value }) => {
      const removeUrl = _buildRemoveUrl(key, value);
      return `<a class="cat-strip-pill" href="${removeUrl}">${value}<span class="cat-strip-x" aria-hidden="true">&times;</span></a>`;
    }).join('');

    pillsContainer.innerHTML = html;
    if (mobChips) mobChips.innerHTML = html;
  }

  function catClearAll() {
    const u = new URL(window.location.href);
    const toDelete = new Set();
    u.searchParams.forEach((_, key) => {
      if (key.startsWith('filter.p.m.custom.')) toDelete.add(key);
    });
    toDelete.forEach(key => u.searchParams.delete(key));
    window.location.href = u.toString();
  }
  window.catClearAll = catClearAll;

  /* ─────────────────────────────────────────────────────────────────
     MOBILE FILTER SHEET
     Filter button opens a bottom sheet with accordion filters.
     Overlay and close button dismiss it. Single-open accordion.
     Filter links inside the sheet preserve ?view=category-catalogue.
  ───────────────────────────────────────────────────────────────── */
  function bindMobileSheet() {
    const filterBtn = document.getElementById('cat-mob-filter-btn');
    const overlay   = document.getElementById('cat-mob-overlay');
    const sheet     = document.getElementById('cat-mob-sheet');
    const closeBtn  = document.getElementById('cat-mob-sheet-close');
    const doneBtn   = document.getElementById('cat-mob-sheet-done');
    if (!filterBtn || !overlay || !sheet) return;

    function openSheet() {
      overlay.classList.add('is-open');
      overlay.removeAttribute('aria-hidden');
      sheet.classList.add('is-open');
      sheet.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    filterBtn.addEventListener('click', openSheet);
    overlay.addEventListener('click', closeSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (doneBtn)  doneBtn.addEventListener('click', closeSheet);

    /* Reopen sheet after a filter link navigation (multi-select support) */
    if (sessionStorage.getItem('catSheetOpen')) {
      sessionStorage.removeItem('catSheetOpen');
      openSheet();
      const savedAccordion = sessionStorage.getItem('catSheetAccordion');
      if (savedAccordion) {
        sessionStorage.removeItem('catSheetAccordion');
        const toggle = sheet.querySelector(`[aria-controls="${savedAccordion}"]`);
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          const body = document.getElementById(savedAccordion);
          if (body) body.classList.remove('hidden');
        }
      }
    }

    /* Single-open accordion */
    const toggles = sheet.querySelectorAll('[data-mob-toggle]');
    toggles.forEach(btn => {
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        toggles.forEach(other => {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            const body = document.getElementById(other.getAttribute('aria-controls'));
            if (body) body.classList.add('hidden');
          }
        });
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        const body = document.getElementById(btn.getAttribute('aria-controls'));
        if (body) body.classList.toggle('hidden', isOpen);
      });
    });

    /* Persist sheet state + preserve view param on all filter links in sheet */
    sheet.addEventListener('click', e => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript')) return;

      const openToggle = sheet.querySelector('[data-mob-toggle][aria-expanded="true"]');
      sessionStorage.setItem('catSheetOpen', '1');
      sessionStorage.setItem('catSheetAccordion', openToggle ? openToggle.getAttribute('aria-controls') : '');

      try {
        const u = new URL(href, window.location.origin);
        if (u.searchParams.get('view') !== 'category-catalogue') {
          u.searchParams.set('view', 'category-catalogue');
          e.preventDefault();
          window.location.href = u.toString();
        }
      } catch (_) { /* malformed href — let browser handle */ }
    });
  }

  /* ─────────────────────────────────────────────────────────────────
     RANDOMIZE CARD IMAGES
     On each call, picks a random image from data-images for every
     product card. Called at init, after pill DOM swaps, and after
     load-more appends new cards.
  ───────────────────────────────────────────────────────────────── */
  function randomizeCardImages() {
    document.querySelectorAll('.tds-card-img[data-images]').forEach(img => {
      const srcs = img.dataset.images.split('|').filter(Boolean);
      /* Exclude all pattern tile images: raw .png tiles and tessara-tiled-* jpegs */
      const pickable = srcs.filter(s => !s.includes('tessara-tiled-') && !/\.png(\?|$)/i.test(s));
      if (pickable.length < 2) return;
      const pick = pickable[Math.floor(Math.random() * pickable.length)];
      const setW = (s, w) => s.replace(/([?&])width=\d+/, '$1width=' + w);
      img.src    = setW(pick, 500);
      img.srcset = `${setW(pick, 250)} 250w, ${setW(pick, 500)} 500w, ${setW(pick, 750)} 750w`;
    });
  }

  /* ─────────────────────────────────────────────────────────────────
     POPSTATE — restore grid on browser back/forward
  ───────────────────────────────────────────────────────────────── */
  window.addEventListener('popstate', async () => {
    const catPage   = window.__catPage || {};
    const sectionId = catPage.sectionId || 'category-catalogue';
    const fetchUrl  = window.location.href + (window.location.href.includes('?') ? '&' : '?') + 'sections=' + sectionId;
    try {
      const res = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      const html = data[sectionId];
      if (!html) throw new Error('section missing');
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newContent = tmp.querySelector('.cat-page--grid');
      const current    = document.querySelector('.cat-page--grid');
      if (current && newContent) {
        current.replaceWith(newContent);
        bindPills();
        bindCategoryTabs();
        bindDesignLineFilters();
        bindStickyBack();
        bindQuickView();
        bindSetPicker();
        bindFilterbarAccordions();
        bindFilterbarLinks();
        bindFilterSearch();
        bindLoadMore();
        bindActiveStrip();
        bindMobileSheet();
        randomizeCardImages();
      }
    } catch (_) {
      window.location.reload();
    }
  });

  /* ── Init ── */
  function init() {
    bindPills();
    bindCategoryTabs();
    bindDesignLineFilters();
    bindStickyBack();
    bindQuickView();
    bindSetPicker();
    bindFilterbarAccordions();
    bindFilterbarLinks();
    bindFilterSearch();
    bindLoadMore();
    bindActiveStrip();
    bindMobileSheet();
    randomizeCardImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
